import { PositionScenarios } from "../../types";

export const lcsScenarios: PositionScenarios = {
  "1": {
    "1": [
      { "3": 1, "7": 0, "10": 0, "11": 1, "12": 1 },
      { "3": 0, "9": 1, "11": 0, "12": 1 },
      { "3": 0, "9": 0, "12": 0 },
    ],
    "2": [
      { "4": 1, "8": 0, "10": 1, "11": 1, "12": 1 },
      { "4": 0, "9": 0, "11": 0, "12": 1 },
      { "4": 0, "9": 1, "12": 0 },
    ],
    "3": [
      { "2": 0, "4": 0, "8": 0, "10": 1, "11": 1, "12": 1 },
      { "2": 1, "5": 0, "7": 1, "10": 0, "11": 1, "12": 1 },
      { "2": 0, "4": 1, "9": 0, "11": 0, "12": 1 },
      { "2": 0, "4": 1, "9": 1, "12": 0 },
    ],
    "4": [
      { "1": 1, "3": 0, "7": 0, "10": 0, "11": 1, "12": 1 },
      { "1": 0, "6": 0, "8": 1, "10": 1, "11": 1, "12": 1 },
      { "1": 1, "3": 1, "9": 1, "11": 0, "12": 1 },
      { "1": 1, "3": 1, "9": 0, "12": 0 },
    ],
    "5": [
      { "1": 0, "3": 0, "7": 0, "10": 0, "11": 1, "12": 1 },
      { "1": 1, "6": 0, "8": 1, "10": 1, "11": 1, "12": 1 },
      { "1": 0, "3": 1, "9": 1, "11": 0, "12": 1 },
      { "1": 0, "3": 1, "9": 0, "12": 0 },
    ],
    "6": [
      { "2": 1, "4": 0, "8": 0, "10": 1, "11": 1, "12": 1 },
      { "2": 0, "5": 0, "7": 1, "10": 0, "11": 1, "12": 1 },
      { "2": 1, "4": 1, "9": 0, "11": 0, "12": 1 },
      { "2": 1, "4": 1, "9": 1, "12": 0 },
    ],
    "7": [{ "5": 1, "7": 1, "10": 0, "11": 1, "12": 1 }],
    "8": [{ "6": 1, "8": 1, "10": 1, "11": 1, "12": 1 }],
  },
  "2": {
    "1": [
      { "3": 1, "7": 0, "10": 0, "11": 1, "12": 0 },
      { "3": 0, "9": 1, "11": 0, "12": 0 },
      { "3": 0, "9": 0, "12": 1 },
    ],
    "2": [
      { "4": 1, "8": 0, "10": 1, "11": 1, "12": 0 },
      { "4": 0, "9": 0, "11": 0, "12": 0 },
      { "4": 0, "9": 1, "12": 1 },
    ],
    "3": [
      { "2": 0, "4": 0, "8": 0, "10": 1, "11": 1, "12": 0 },
      { "2": 1, "5": 0, "7": 1, "10": 0, "11": 1, "12": 0 },
      { "2": 0, "4": 1, "9": 0, "11": 0, "12": 0 },
      { "2": 0, "4": 1, "9": 1, "12": 1 },
    ],
    "4": [
      { "1": 1, "3": 0, "7": 0, "10": 0, "11": 1, "12": 0 },
      { "1": 0, "6": 0, "8": 1, "10": 1, "11": 1, "12": 0 },
      { "1": 1, "3": 1, "9": 1, "11": 0, "12": 0 },
      { "1": 1, "3": 1, "9": 0, "12": 1 },
    ],
    "5": [
      { "1": 0, "3": 0, "7": 0, "10": 0, "11": 1, "12": 0 },
      { "1": 1, "6": 0, "8": 1, "10": 1, "11": 1, "12": 0 },
      { "1": 0, "3": 1, "9": 1, "11": 0, "12": 0 },
      { "1": 0, "3": 1, "9": 0, "12": 1 },
    ],
    "6": [
      { "2": 1, "4": 0, "8": 0, "10": 1, "11": 1, "12": 0 },
      { "2": 0, "5": 0, "7": 1, "10": 0, "11": 1, "12": 0 },
      { "2": 1, "4": 1, "9": 0, "11": 0, "12": 0 },
      { "2": 1, "4": 1, "9": 1, "12": 1 },
    ],
    "7": [{ "5": 1, "7": 1, "10": 0, "11": 1, "12": 0 }],
    "8": [{ "6": 1, "8": 1, "10": 1, "11": 1, "12": 0 }],
  },
  "3": {
    "1": [
      { "3": 1, "7": 0, "10": 0, "11": 0 },
      { "3": 0, "9": 1, "11": 1 },
    ],
    "2": [
      { "4": 1, "8": 0, "10": 1, "11": 0 },
      { "4": 0, "9": 0, "11": 1 },
    ],
    "3": [
      { "2": 0, "4": 0, "8": 0, "10": 1, "11": 0 },
      { "2": 1, "5": 0, "7": 1, "10": 0, "11": 0 },
      { "2": 0, "4": 1, "9": 0, "11": 1 },
    ],
    "4": [
      { "1": 1, "3": 0, "7": 0, "10": 0, "11": 0 },
      { "1": 0, "6": 0, "8": 1, "10": 1, "11": 0 },
      { "1": 1, "3": 1, "9": 1, "11": 1 },
    ],
    "5": [
      { "1": 0, "3": 0, "7": 0, "10": 0, "11": 0 },
      { "1": 1, "6": 0, "8": 1, "10": 1, "11": 0 },
      { "1": 0, "3": 1, "9": 1, "11": 1 },
    ],
    "6": [
      { "2": 1, "4": 0, "8": 0, "10": 1, "11": 0 },
      { "2": 0, "5": 0, "7": 1, "10": 0, "11": 0 },
      { "2": 1, "4": 1, "9": 0, "11": 1 },
    ],
    "7": [{ "5": 1, "7": 1, "10": 0, "11": 0 }],
    "8": [{ "6": 1, "8": 1, "10": 1, "11": 0 }],
  },
  "4": {
    "1": [{ "3": 1, "7": 0, "10": 1 }],
    "2": [{ "4": 1, "8": 0, "10": 0 }],
    "3": [
      { "2": 0, "4": 0, "8": 0, "10": 0 },
      { "2": 1, "5": 0, "7": 1, "10": 1 },
    ],
    "4": [
      { "1": 1, "3": 0, "7": 0, "10": 1 },
      { "1": 0, "6": 0, "8": 1, "10": 0 },
    ],
    "5": [
      { "1": 0, "3": 0, "7": 0, "10": 1 },
      { "1": 1, "6": 0, "8": 1, "10": 0 },
    ],
    "6": [
      { "2": 1, "4": 0, "8": 0, "10": 0 },
      { "2": 0, "5": 0, "7": 1, "10": 1 },
    ],
    "7": [{ "5": 1, "7": 1, "10": 1 }],
    "8": [{ "6": 1, "8": 1, "10": 0 }],
  },
  "5": {
    "1": [],
    "2": [],
    "3": [],
    "4": [],
    "5": [],
    "6": [],
    "7": [],
    "8": [],
  },
  "6": {
    "1": [],
    "2": [],
    "3": [],
    "4": [],
    "5": [],
    "6": [],
    "7": [],
    "8": [],
  },
};
